export default "__VITE_ASSET__BuN5Nuiu__";